import { render, staticRenderFns } from "./CmgChipotleURewardsExchangeHeadBanner.vue?vue&type=template&id=124e857f&scoped=true&lang=pug"
import script from "./cmg-chipotle-u-rewards-exchange-head-banner.ts?vue&type=script&lang=ts&external"
export * from "./cmg-chipotle-u-rewards-exchange-head-banner.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgChipotleURewardsExchangeHeadBanner.vue?vue&type=style&index=0&id=124e857f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124e857f",
  null
  
)

export default component.exports